module.exports = __webpack_public_path__ + "img/35.d2eb0d8c.jpg";